/** Resolve a visible blank from stable answer IDs, including paired 太…了 gaps. */
export function terminalSentence(payload:any,feedback:any){
 if(!payload?.sentence?.segments)return null;
 const result=feedback?.normalizedResult??{},id=String(result.correctChoiceId??result.acceptedAnswerIds?.[0]??result.selectedChoiceId??'');
 const choice=(payload.choices??payload.options??[]).find((row:any)=>String(row.choiceId??row.id)===id);
 if(!choice)return null;
 const label=String(choice.label??choice.text??''),parts=label.split(/…+|\.{3,}/);
 return payload.sentence.segments.map((segment:any)=>{
  if(typeof segment==='string')return segment;
  if(segment.blank||segment.blankId||segment.text==='____')return Number.isInteger(segment.choicePart)?parts[segment.choicePart]??label:label;
  return segment.text??'';
 }).join('');
}

/** Fill the published pinyin template with the same stable answer as the Hanzi. */
export function terminalPinyin(payload:any,feedback:any,recorded?:any){
 const template=String(recorded??payload?.sentence?.pinyin??'');
 if(!/…|\.{3,}|_{2,}/.test(template))return template||undefined;
 const result=feedback?.normalizedResult??{},id=String(result.correctChoiceId??result.acceptedAnswerIds?.[0]??result.selectedChoiceId??'');
 const choice=(payload.choices??payload.options??[]).find((row:any)=>String(row.choiceId??row.id)===id);
 if(!choice?.pinyin)return undefined;
 const parts=String(choice.pinyin).split(/…+|\.{3,}/);let index=0;
 return template.replace(/\(?\s*(?:…+|\.{3,}|_{2,})\s*\)?/g,()=>` ${parts[Math.min(index++,parts.length-1)]} `).replace(/\s+([,.?!，。？！])/g,'$1').replace(/\s+/g,' ').trim();
}
